import React from 'react';
import { Row, Col, Form, Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type CarMileageAddressInputsProps = {
  addressFrom: string;
  addressTo: string;
  onAddressFromChange: (address: string) => void;
  onAddressToChange: (address: string) => void;
};

export const CarMileageAddressInputs: React.FC<
  CarMileageAddressInputsProps
> = ({ addressFrom, addressTo, onAddressFromChange, onAddressToChange }) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>
            <Badge bg="success" className="me-2">
              A
            </Badge>
            {t('expenses.carMileageForm.addressFrom')}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={t('expenses.carMileageForm.enterAddress')}
            value={addressFrom}
            onChange={(e) => onAddressFromChange(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>
            <Badge bg="danger" className="me-2">
              B
            </Badge>
            {t('expenses.carMileageForm.addressTo')}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={t('expenses.carMileageForm.enterAddress')}
            value={addressTo}
            onChange={(e) => onAddressToChange(e.target.value)}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};
